import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import isEqual from 'lodash/isEqual';
import { Types, Selectors, Actions } from '@grandvisionhq/auth';
import { toast } from '@grandvisionhq/common';
import { useDispatch, useSelector, useIntl } from '@grandvisionhq/state';
import { changeFormValue } from '../../../actions.js';
import { usePersonalDetailsFormSlots } from '../../../slots/PersonalDetailsFormSlotsContext.js';
import { toggleFormEditMode } from '../../actions.js';
import { usePersonalDetails } from '../../hooks/use-personal-details.js';
import { toPersonalDetails, mapFormStateToPersonalDetailsType } from '../../mappers/profile.js';
import { getPersonalDetails } from '../../selectors.js';
import { ErrorAlert } from '../ErrorAlert.js';
import { LoadingData } from '../LoadingData.js';
import PersonalDetails from './PersonalDetails.js';

const FORM_NAME = Types.FormName.personalDetails;
const PersonalDetailsContainer = (props)=>{
    const dispatch = useDispatch();
    const auth = useSelector(Selectors.getAuth);
    const intl = useIntl();
    const userId = useSelector(Selectors.getUserId);
    const formState = useSelector(getPersonalDetails, (previousState, newState)=>isEqual(previousState, newState)
    );
    const { Slots  } = usePersonalDetailsFormSlots();
    const openEditMode = React__default.useCallback(()=>dispatch(toggleFormEditMode({
            formName: Types.FormName.personalDetails,
            inEditMode: true
        }))
    , [
        dispatch
    ]);
    const closeEditMode = React__default.useCallback(()=>dispatch(toggleFormEditMode({
            formName: Types.FormName.personalDetails,
            inEditMode: false
        }))
    , [
        dispatch
    ]);
    const onCompleted = React__default.useCallback(({ reason , data  })=>{
        if (reason === 'QUERY') {
            var ref;
            dispatch(Actions.UserDataActions.fetchUserDataSuccess({
                [FORM_NAME]: toPersonalDetails((ref = data.me) === null || ref === void 0 ? void 0 : ref.personalDetails)
            }));
        }
        if (reason === 'MUTATION') {
            var ref1;
            dispatch(Actions.UserDataActions.updateUserDataSuccess({
                formName: FORM_NAME,
                server: {
                    [FORM_NAME]: toPersonalDetails((ref1 = data.updateB2CPersonalDetails) === null || ref1 === void 0 ? void 0 : ref1.personalDetails)
                }
            }));
            toast.success('account.updateProfile.success');
        }
        closeEditMode();
    }, [
        dispatch,
        closeEditMode
    ]);
    const onError = React__default.useCallback(({ reason , error  })=>{
        if (reason === 'QUERY') {
            dispatch(Actions.UserDataActions.fetchUserDataFailed(error));
        }
        if (reason === 'MUTATION') {
            dispatch(Actions.UserDataActions.updateUserDataFailed({
                error,
                formName: FORM_NAME
            }));
            toast.failed('account.profile.settings.saveFailed');
        }
    }, [
        dispatch
    ]);
    const { personalDetailsData , isFetching , isUpdating , updatePersonalDetails , fetchError  } = usePersonalDetails({
        onCompleted,
        onError
    });
    if (isFetching || !userId) {
        return /*#__PURE__*/ React__default.createElement(LoadingData, null);
    }
    if (fetchError) {
        return /*#__PURE__*/ React__default.createElement(ErrorAlert, {
            message: intl.getFormattedLabel('account.personalDetails.errors.network.general', {
                parseLink: true
            })
        });
    }
    const handleFormChange = (form)=>{
        dispatch(changeFormValue({
            form
        }));
    };
    const handleSavePersonalDetails = function() {
        var _ref = swcHelpers.asyncToGenerator(function*() {
            if (formState === null || formState === void 0 ? void 0 : formState.state.formValid) {
                const newData = mapFormStateToPersonalDetailsType(formState.state.formState);
                yield updatePersonalDetails(newData, userId);
            }
        });
        return function handleSavePersonalDetails() {
            return _ref.apply(this, arguments);
        };
    }();
    const personalDetailsLabels = {
        add: intl.getLabel('account.profile.personalDetails.add'),
        close: intl.getLabel('common.actions.cancel'),
        contact: intl.getFormattedLabel('account.profile.customerCare', {
            parseLink: true,
            parseHTML: true
        }),
        email: intl.getLabel('checkout.contact.email'),
        intro: intl.getLabel('account.profile.personalDetails.intro'),
        modalInfo: intl.getLabel('account.profile.settings.modal.info'),
        modalTitle: intl.getLabel('account.profile.personalDetails.edit'),
        noDetails: intl.getLabel('account.profile.personalDetails.noDetails'),
        save: intl.getLabel('account.action.save')
    };
    return /*#__PURE__*/ React__default.createElement(PersonalDetails, swcHelpers.extends({}, props, {
        Slots: Slots,
        hasNoData: Object.values(personalDetailsData).every((x)=>x === null || x === ''
        ),
        labels: personalDetailsLabels,
        email: auth.email,
        isUpdating: isUpdating,
        personalDetailsData: personalDetailsData,
        formState: formState,
        handleFormChange: handleFormChange,
        handleSavePersonalDetails: handleSavePersonalDetails,
        toggleEditMode: openEditMode,
        closeEditMode: closeEditMode
    }));
};
var PersonalDetailsContainer$1 = PersonalDetailsContainer;

export { PersonalDetailsContainer$1 as default };
//# sourceMappingURL=PersonalDetailsContainer.js.map
